import {takeLatest} from "redux-saga";
import {fork, put, take} from "redux-saga/effects";
import {generateUUID} from "../lib/UUID";
import * as ConsignmentApiActions from "../actions/ConsignmentApiActions";
import {
  showModalWindow,
  removeModalWindow,
  } from "../actions/WindowActions";
import {Map} from "immutable";


function* requestConsignmentCommand(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "ConsignmentCommandWindow", {consignmentAndActivities: baseAction.consignmentAndActivities, report: baseAction.report}, "Update Tracking"));
  yield take([ConsignmentApiActions.CONSIGNMENT_COMMAND.CANCEL, ConsignmentApiActions.CONSIGNMENT_COMMAND.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestConsignmentCommand() {
  yield takeLatest(ConsignmentApiActions.REQUEST_CONSIGNMENT_COMMAND, requestConsignmentCommand);
}

function* requestConsignmentDetails(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "ConsignmentDetailsWindow", {consignmentAndActivities: baseAction.consignmentAndActivities}, "Consignment Details", Map({width: "90vw"})));
  yield take([ConsignmentApiActions.CONSIGNMENT_DETAILS.CANCEL, ConsignmentApiActions.CONSIGNMENT_DETAILS.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestConsignmentDetails() {
  yield takeLatest(ConsignmentApiActions.REQUEST_CONSIGNMENT_DETAILS, requestConsignmentDetails);
}

export default function* saga() {
  yield fork(watchRequestConsignmentCommand);
  yield fork(watchRequestConsignmentDetails);
}
